import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=c9b60d96&scoped=true&"
import script from "./DetailDialog.vue?vue&type=script&lang=js&"
export * from "./DetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b60d96",
  null
  
)

export default component.exports